import React from 'react';
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBCard, MDBCardBody, MDBInput, MDBIcon } from 'mdbreact';
import { Redirect } from 'react-router-dom';
import DataLayer from '../Utilities/DataLayer';


export default class ForgotPin extends React.Component {

    constructor(props) {
        super();
        this.state = {
            mobiVersion: global.appVersion,
            msgHidden: true,
            msg: '',
            success: true,
            submitEnabled: true
        }

        this.SubmitLogin = this.SubmitLogin.bind(this);

    }

    async SubmitLogin(event) {
        event.preventDefault();
        let dataLayer = new DataLayer();
        let requestObject = { "SMSQueryCell": event.target.elements.SMSQueryCell.value };
        let response = await dataLayer.ResetPin(requestObject);
        this.setState({ msgHidden: false, msg: response.data.otherInfo, success: response.data.data, submitEnabled: !response.data.data })

        var tester = "";
        //let dataLayer = new DataLayer();
        //let loginObject = { "IsPWA": 1, "SMSQueryCell": event.target.elements.SMSQueryCell.value, };
        //let loginSuccess = await dataLayer.Login(loginObject);
        //const { history } = this.props;

        //if (loginSuccess) {
        //    var TMAUser = JSON.parse(localStorage.getItem("TMAUser"));
        //    //alert("Terms Accepted " + TMAUser.data.acceptedTerms)
        //    if (TMAUser.data.acceptedTerms) {
        //        history.push('/salesforce');
        //    } else {
        //        history.push('/termsandconditions');
        //    }
        //}
    }

    render() {
        return (
            <MDBContainer>
                <MDBCard className="mt-5">
                    <MDBCardBody>
                        <MDBRow>
                            <MDBCol>
                                <span style={{ fontSize: "12px", color: "#666a6e", textDecoration: "underline" }}>Mobi Version: {this.state.mobiVersion}</span>
                            </MDBCol>
                        </MDBRow>
                        <div className="text-center pt-5">
                            <img src={require('../Assets/Images/loginLogo.png')} />
                        </div>

                        <MDBRow>
                            <MDBCol style={{ textAlign: 'center' }}><span style={{ fontSize: "14px", color: "#666a6e" }}>Enter your Cell Phone number and click submit to reset your pin. You'll receive an SMS with your new pin.</span></MDBCol>
                        </MDBRow>
                        <div hidden={ this.state.msgHidden}>
                            <MDBRow>
                                <MDBCol style={{ textAlign: 'center' }}><span style={{ fontSize: "14px", color: this.state.success ? "darkgreen" : "red" }}>{ this.state.msg}</span></MDBCol>
                            </MDBRow>
                        </div>
                        <form onSubmit={this.SubmitLogin}>
                            <MDBInput label="Cell Phone Number" type="text" name="SMSQueryCell" />
                            <MDBRow>
                                <MDBCol>
                                    <MDBBtn disabled={!this.state.submitEnabled} type="submit">Submit</MDBBtn>
                                </MDBCol>

                            </MDBRow>
                        </form>
                    </MDBCardBody>
                </MDBCard>
            </MDBContainer>
        );
    }
}